module.exports = __webpack_public_path__ + "static/usa-e3913d6807548da2fe2669d4fb3da483.jpeg";